import { Image, Spin, Table, Space, Card, Col, Row } from "antd";
import { useState, useEffect } from "react";
import { get } from "../../services";
import { useParams, useNavigate } from "react-router-dom";

const UserDetail = () => {
  const [userDetail, setUserDetail] = useState([]);
  const [loader, setLoader] = useState(true);
  const params = useParams();
  const navigate = useNavigate();
  // handler to get data for
  const getUserDetailHandler = () => {
    get(`/hostaway/getListing/${params.id}`)
      .then((response) => {
        setLoader(false);
        setUserDetail(response?.data);
      })
      .catch((error) => {
        setLoader(false);
      });
  };

  // API for
  useEffect(() => {
    getUserDetailHandler();
    // eslint-disable-next-line
  }, []);

  // onChange
  // const onChange = (key) => {
  //   console.log(key);
  //   getUserDetailHandler(key);
  // };
  // console.log(userDetail);

  const columns = [
    {
      title: "listing Id",
      dataIndex: "listingId",
      key: "listingId",
      render: (data) => <Space>{data}</Space>,
    },
    {
      title: "Person Capacity",
      dataIndex: "",
      key: "profile",
      render: (data) => (
        <div>
          <Space size="middle" style={{ padding: "0px 10px" }}>
            {data?.personCapacity}
          </Space>
        </div>
      ),
    },
    {
      title: "CheckIn Time",
      dataIndex: "checkInTimeStart",
      key: "checkInTimeStart",
      render: (data) => (
        <Space size="middle">
          <Space size="middle">{data || "-"}</Space>
        </Space>
      ),
    },
    {
      title: "CheckOut Time",
      dataIndex: "checkOutTime",
      key: "checkOutTime",
      render: (data) => (
        <Space size="middle">
          <Space size="middle">{data || "-"}</Space>
        </Space>
      ),
    },
    {
      title: "Bedrooms",
      dataIndex: "bedroomsNumber",
      key: "bedroomsNumber",
      render: (data) => (
        <Space size="middle">
          <Space size="middle">{data || "-"}</Space>
        </Space>
      ),
    },
    {
      title: "Bathrooms ",
      dataIndex: "bathroomsNumber",
      key: "bathroomsNumber",
      render: (data) => (
        <Space size="middle">
          <Space size="middle">{data || "-"}</Space>
        </Space>
      ),
    },
    {
      title: "Beds",
      dataIndex: "bedsNumber",
      key: "bedsNumber",
      render: (data) => (
        <Space size="middle">{data === null ? "-" : data}</Space>
      ),
    },
  ];
  return (
    <div className="property-details-container">
      {loader ? (
        <div className="spin_information">
          <Spin />
        </div>
      ) : (
        <div>
          <div className="header ">
            <h3 style={{ padding: "0px 0px 15px 0px" }}>Property Detail</h3>
            <div className="user-details-back">
              <button onClick={() => navigate(-1)} className="cursor-point">Back</button>
            </div>
          </div>
          <div className="images-container">
            {userDetail?.listingImages?.map((item) => (
              <Image width={200} src={item?.url} />
            ))}
          </div>
          <div className="description">
            <div>
              <h3>{userDetail?.name}</h3>
              <br />
              <h3>
                Price: <span>{userDetail?.price} AED</span>
              </h3>
              <br />
              <h3>Description</h3>
              <p className="content">{userDetail?.description}</p>
            </div>
          </div>
          <div style={{ padding: "30px 0px" }}>
            <Table
              columns={columns}
              dataSource={[userDetail]}
              loading={false}
              pagination={false}
              scroll={{ x: 1023 }}
            />
          </div>

          <Card title="Aminities">
            <Row  scroll={{ x: 1023 }}>
              {userDetail?.listingAmenities?.map((item, index) => (
                <Col key={index} xs={24} sm={24} md={12} lg={8} xxl={6}>
                  <Card.Grid style={{ width: "100%" }}>
                    {item?.amenityName}
                  </Card.Grid>
                </Col>
              ))}
            </Row>
          </Card>
        </div>
      )}
    </div>
  );
};
export default UserDetail;
